var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIphone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 34,
    viewBox: "0 0 22 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.10882 33.8756H16.9515C19.5128 33.8756 21.2154 32.2031 21.2154 29.7171V5.06752C21.2154 2.58148 19.5128 0.909042 16.9515 0.909042H5.10882C2.5173 0.909042 0.769531 2.58148 0.769531 5.06752V29.7171C0.769531 32.2031 2.5173 33.8756 5.10882 33.8756ZM5.60603 30.8471C4.41574 30.8471 3.72266 30.1842 3.72266 29.0391V5.74554C3.72266 4.60045 4.41574 3.95257 5.60603 3.95257H16.394C17.5843 3.95257 18.2773 4.60045 18.2773 5.74554V29.0391C18.2773 30.1842 17.5843 30.8471 16.394 30.8471H13.4408V30.3198C13.4408 29.6568 13.0039 29.2199 12.356 29.2199H9.65904C8.99609 29.2199 8.57422 29.6568 8.57422 30.3198V30.8471H5.60603Z",
    fill: "#BF50B2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIphone);
export default __webpack_public_path__ + "static/media/iphone.c62950031b73d421559dca8562eaf9f1.svg";
export { ForwardRef as ReactComponent };